
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndManual/create",
      function () {
        return require("private-next-pages/remyndManual/create.tsx");
      }
    ]);
  